import React, { useState, useEffect } from "react";
import "./Library.scss";

import img from "../../assets/Infrastructure/Library/img (1).jpeg";
import img1 from "../../assets/Infrastructure/Library/img (1).jpg";
import img2 from "../../assets/Infrastructure/Library/img (2).jpeg";
import img3 from "../../assets/Infrastructure/Library/img (3).jpeg";


const images = [img, img1, img2, img3];

const Library = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="library">
      <div className="container">
        <h1 className="page-title">ABOUT LIBRARY</h1>

        {/* IMAGE CAROUSEL */}
        <div className="library-carousel">
          {images.map((img, index) => (
            <div
              key={index}
              className={`slide ${index === current ? "active" : ""}`}
            >
              <img src={img} alt={`Library ${index + 1}`} />
            </div>
          ))}
        </div>

        {/* CONTENT */}
        <div className="content-card">
          <p className="intro">
            The <strong>Library of Bengaluru Law College</strong> serves as the
            intellectual hub and knowledge center of the institution. It supports
            teaching, learning, and research by providing access to a wide range
            of legal and academic resources, fostering a culture of reading,
            research, and self-learning.
          </p>

          <h2>Library Rules & Timings</h2>

          <ul className="rules">
            <li>
              The college library is open from <strong>9:00 AM to 5:00 PM</strong>,
              Monday to Saturday.
            </li>
            <li>
              Each student will be issued a maximum of <strong>two books</strong>{" "}
              at a time.
            </li>
            <li>
              Books must be returned within <strong>15 days</strong> from the date
              of issue to avoid penalty.
            </li>
            <li>
              A fine of <strong>₹2 per day</strong> will be charged beyond the due
              date.
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Library;
